var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVictoryReactionsWowFill = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 306.64 306.64",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.32,
    cy: 210.67,
    rx: 31.58,
    ry: 34.62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.32,0C68.78,0,0,68.78,0,153.32S68.78,306.64,153.32,306.64s153.32-68.78,153.32-153.32S237.86,0,153.32,0Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 109.92,
    cy: 123,
    r: 12,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.72,
    cy: 123,
    r: 12,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,92.57c18-22.23,40.51-30.12,64.7-14.55",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.16,78.79c25.6-12.74,49.37-10.53,64.88,13.7",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.32,
    cy: 210.67,
    rx: 46.01,
    ry: 49.24,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "25.06999969482422px"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVictoryReactionsWowFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Victory_Reactions_WowFill.32e200a9.svg";
export { ForwardRef as ReactComponent };